module.exports = __webpack_public_path__ + "static/js/mailMerges.9ba704f4.chunk.worker.js"